import { render, staticRenderFns } from "./CollectorAccountList.vue?vue&type=template&id=2d5f2ede&"
import script from "./CollectorAccountList.vue?vue&type=script&lang=js&"
export * from "./CollectorAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports